import { logger } from "@jslib/shared/utils/logger";

import { type ProgramTheme, type ReduxState } from "../../types/types";
import { deepClone } from "../../utils/objects";
import { createUpdateProgramTheme } from "../VerificationServiceActions";
import { getStore } from "../VerificationServiceStore";
import { addHook } from "../../hooks";
import { mergeProgramBaseline } from "../../state/programStore";

export const setProgramTheme = (
  newProgramTheme: ProgramTheme | {},
  options: { partial: boolean } = { partial: true },
) => {
  const store = getStore();
  const state: ReduxState = store.getState();
  const doSet = () => {
    const updatedProgramTheme = deepClone(newProgramTheme);
    logger.info("Setting programTheme", updatedProgramTheme);
    createUpdateProgramTheme(store.dispatch)(updatedProgramTheme, options.partial);
    mergeProgramBaseline(updatedProgramTheme, options.partial);
  };

  if (state.isLoading) {
    addHook({
      name: "ON_VERIFICATION_READY",
      callback: () => {
        doSet();
      },
    });
  } else {
    doSet();
  }
};
